// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_Twy","cls2":"AppsMegaMenu-cls2_1ib AppsMegaMenu-cls1_Twy"};